<template>
  <div class="d-lg-flex half">
    <loading
      :active="isLoaderActive"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="bg order-1 order-md-2 bg-image-login align-middle d-flex">
      <div
        class="d-table-cell align-middle"
        style="margin-top: auto; margin-bottom: auto"
      >
        <img class="img-fluid" src="@/assets/img/LogoBlurPapirus.png" :width="width" />
      </div>
    </div>
    <div class="contents order-2 order-md-1">
      <div class="container bg-light">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-7">
            <div id="notifyPopup" ref="notifybarObj"></div>
            <p class="mb-4">
              <img src="@/assets/img/logohdicolor.png" />
            </p>
            <h3>Establecer Contraseña - Sistema <strong>Papirus</strong></h3>
            <div class="text-left">
              <div class="form-group first">
                <label for="NewPassword">Nueva Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Contraseña"
                  id="NewPassword"
                  autocomplete="off"
                  v-model="ValidModel.NewPassword"
                  @input="validateField('NewPassword')"
                  @blur="validateField('NewPassword')"
                />
                <small
                  class="form-text"
                  :class="{ 'text-danger': hasError('NewPassword') }"
                  v-if="hasError('NewPassword')"
                >
                  {{ m_errors.NewPassword }}
                </small>
              </div>
              <div class="form-group last mb-3">
                <label for="ConfirmPassword">Confirmar Contraseña</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="Confirmar Contraseña"
                  id="ConfirmPassword"
                  v-model="ValidModel.ConfirmPassword"
                  autocomplete="off"
                  @input="validateField('ConfirmPassword')"
                  @blur="validateField('ConfirmPassword')"
                  @keyup.enter="SetPassword()"
                />
                <small
                  class="form-text"
                  :class="{ 'text-danger': hasError('ConfirmPassword') }"
                  v-if="hasError('ConfirmPassword')"
                >
                  {{ m_errors.ConfirmPassword }}
                </small>
              </div>

              <input
                type="button"
                value="Establecer Contraseña"
                class="btn btn-block btn-primary"
                @click.prevent="SetPassword()"
              />
            </div>
            <div style="margin-top: 15px">
              <router-link to="/">Volver</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import ToastMixin from "../../mixins/ToastMixin";

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

import { Browser } from "@syncfusion/ej2-base";
import LoaderMixin from "../../mixins/SpinnerMixin";
/* https://www.npmjs.com/package/vue-loading-overlay */
import Loading from "vue-loading-overlay";
import store from "../../store/ForgotPassword.js";

Vue.use(Loading);
// Vue.mixin();

export default Vue.extend({
  mixins: [LoaderMixin, ToastMixin],
  components: { Loading },
  computed: {
    ErrorState() {
      return store.getters.errors;
    },
    isMobile() {
      return Browser.isDevice;
    },
    width() {
      return this.isMobile ? "50%" : "80%";
    }
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("securityParams/getSecurityParams");
    let params = this.$store.getters["securityParams/currentSecurityParams"];
    this.m_data_params = JSON.parse(JSON.stringify(params));
    this.buildYupSchema();
  },
  data() {
    return {
      ValidModel: {
        NewPassword: "",
        ConfirmPassword: ""
      },
      m_errors: {},
      validationSchema: {},
      m_data_params: {}
    };
  },
  methods: {
    async SetPassword() {
      var valid = await this.validateForm();
      if (valid) {
        let payload = {
          data: {
            NewPassword: this.ValidModel.NewPassword,
            ConfirmPassword: this.ValidModel.ConfirmPassword
          }
        };
        try {
          this.showLoading();
          await store.dispatch("SetForgotPasswordHandler", payload);
          this.showToast(
            "Correcto",
            "La contraseña se establecio correctamente",
            2000
          );
          await this.$router.push("Login");
          this.hideLoading(500);
        } catch (error) {
          this.m_errors = {};
          this.hideLoading();
          this.showToast("Oops", store.getters.errors.message, 2000);
        }
      }
    },
    buildYupSchema() {
      var regexPass = new RegExp(this.m_data_params.regexPass);
      var messagePass = this.calculateMessageRegex();

      this.validationSchema = Yup.object().shape({
        NewPassword: Yup.string()
          .required()
          .matches(regexPass, messagePass)
          .label("Nueva Contraseña"),
        ConfirmPassword: Yup.string()
          .required()
          .matches(regexPass, messagePass)
          .oneOf([Yup.ref("NewPassword")], "Las contraseñas no coinciden")
          .label("Contraseña Confirmada")
      });
    },
    hasError(field) {
      return !!this.m_errors[field];
    },
    async validateField(field) {
      Vue.set(this.m_errors, field, "");

      this.validationSchema.validateAt(field, this.ValidModel).catch((err) => {
        Vue.set(this.m_errors, err.path, err.message);
      });
    },
    async validateForm() {
      try {
        await this.validationSchema.validate(this.ValidModel, {
          abortEarly: false
        });
        this.m_errors = {};
        return true;
      } catch (error) {
        error.inner.forEach((error) => {
          Vue.set(this.m_errors, error.path, error.message);
        });
        return false;
      }
    },
    calculateMessageRegex() {
      var message = `Minimo ${this.m_data_params.minLengthPass} y Maximo ${this.m_data_params.maxLengthPass} carácteres`;

      if (this.m_data_params.reqUpperPass)
        message = message + ", almenos una mayúscula";

      if (this.m_data_params.reqLowerPass)
        message = message + ", almenos una minúscula";

      if (this.m_data_params.reqNumberPass)
        message = message + ", almenos un número";

      if (this.m_data_params.reqSpecialCharacterPass)
        message = message + ", almenos un carácter especial";

      if (!this.m_data_params.aceptSpacePass)
        message = message + ", sin espacios";

      return message;
    }
  }
});
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400&display=swap");
@import "../../../node_modules/vue-loading-overlay/dist/vue-loading.css";
</style>
<style scoped src="@/assets/css/login.min.css"></style>

<style scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-icons/styles/bootstrap4.css";
body {
  font-family: "Roboto", sans-serif;
  background-color: #fff;
}

p {
  color: #b3b3b3;
  font-weight: 300;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: "Roboto", sans-serif;
}

a {
  -webkit-transition: 0.3s all ease;
  -o-transition: 0.3s all ease;
  transition: 0.3s all ease;
}
a:hover {
  text-decoration: none !important;
}

.content {
  padding: 7rem 0;
}

h2 {
  font-size: 20px;
}

.half,
.half .container > .row {
  height: 100vh;
  min-height: 700px;
}

.bg-image-login {
  background-image: url("../../assets/img/loginbg.jpg");
}

@media (max-width: 991.98px) {
  .half .bg {
    height: 200px;
  }
}

.half .contents {
  background: #f6f7fc;
}

.half .contents,
.half .bg {
  width: 50%;
}
@media (max-width: 1199.98px) {
  .half .contents,
  .half .bg {
    width: 100%;
  }
}
.half .contents .form-control,
.half .bg .form-control {
  border: none;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  height: 54px;
  background: #fff;
}
.half .contents .form-control:active,
.half .contents .form-control:focus,
.half .bg .form-control:active,
.half .bg .form-control:focus {
  outline: none;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.half .bg {
  background-size: cover;
  background-position: center;
}

.half a {
  color: #888;
  text-decoration: underline;
}

.half .btn {
  height: 54px;
  padding-left: 30px;
  padding-right: 30px;
}

.half .forgot-pass {
  position: relative;
  top: 2px;
  font-size: 14px;
}

.control {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 14px;
}
.control .caption {
  position: relative;
  top: 0.2rem;
  color: #888;
}

.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
  border-radius: 4px;
}

.control--radio .control__indicator {
  border-radius: 50%;
}

.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc;
}

.control input:checked ~ .control__indicator {
  background: #fb771a;
}

.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #fb8633;
}

.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.9;
  pointer-events: none;
}

.control__indicator:after {
  font-family: "icomoon";
  content: "\e5ca";
  position: absolute;
  display: none;
  font-size: 16px;
  -webkit-transition: 0.3s all ease;
  -o-transition: 0.3s all ease;
  transition: 0.3s all ease;
}

.control input:checked ~ .control__indicator:after {
  display: block;
  color: #fff;
}

.control--checkbox .control__indicator:after {
  top: 50%;
  left: 50%;
  margin-top: -1px;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}

.control--checkbox input:disabled:checked ~ .control__indicator {
  background-color: #7e0cf5;
  opacity: 0.2;
}

div.e-toast .e-toast-close-icon::before {
  content: "\e501";
}

/*! CSS Used from: Embedded */
*,
::after,
::before {
  box-sizing: border-box;
}
@media print {
  *,
  ::after,
  ::before {
    text-shadow: none !important;
    box-shadow: none !important;
  }
}
/*! CSS Used from: Embedded */
.e-toast .e-toast-close-icon::before {
  content: "";
}
.e-toast-container .e-toast > * {
  word-break: break-word;
  word-wrap: break-word;
}
.e-toast-container .e-toast .e-toast-close-icon {
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  height: 24px;
  justify-content: center;
  margin-left: auto;
  width: 24px;
}
.e-toast-container .e-toast .e-toast-close-icon {
  color: #333;
}
/*! CSS Used from: Embedded */
.e-icons {
  font-family: "e-icons";
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none;
}
.e-control [class^="e-"],
.e-control [class*=" e-"] {
  box-sizing: border-box;
}
.e-control *:focus {
  outline: none;
}
/*! CSS Used from: Embedded */
*,
::after,
::before {
  box-sizing: border-box;
}
@media print {
  *,
  ::after,
  ::before {
    text-shadow: none !important;
    box-shadow: none !important;
  }
}
.e-icons {
  font-family: "e-icons";
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none;
}
.e-control [class^="e-"],
.e-control [class*=" e-"] {
  box-sizing: border-box;
}
.e-control *:focus {
  outline: none;
}
.e-icons {
  font-family: "e-icons";
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none;
}
.e-control [class^="e-"],
.e-control [class*=" e-"] {
  box-sizing: border-box;
}
.e-control *:focus {
  outline: none;
}
.e-icons {
  font-family: "e-icons";
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none;
}
*,
::after,
::before {
  box-sizing: border-box;
}
@media print {
  *,
  ::after,
  ::before {
    text-shadow: none !important;
    box-shadow: none !important;
  }
}
/*! CSS Used from: Embedded */
.e-toast .e-toast-close-icon::before {
  content: "";
}
.e-toast-container .e-toast > * {
  word-break: break-word;
  word-wrap: break-word;
}
.e-toast-container .e-toast .e-toast-close-icon {
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  height: 24px;
  justify-content: center;
  margin-left: auto;
  width: 24px;
}
.e-toast-container .e-toast .e-toast-close-icon {
  color: #333;
}
/*! CSS Used from: Embedded */
.e-icons {
  font-family: "e-icons";
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none;
}
/*! CSS Used from: Embedded */
.e-icons {
  font-family: "e-icons";
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none;
}
.e-control [class^="e-"],
.e-control [class*=" e-"] {
  box-sizing: border-box;
}
.e-control *:focus {
  outline: none;
}
/*! CSS Used fontfaces */
</style>
